import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React from "react";
import ReactDOM from "react-dom";
import "./styles/index.css";
import "./styles/index2.css";
import App from "./App";
import { MatomoProvider, createInstance } from "@datapunt/matomo-tracker-react";

const instance = createInstance({
  urlBase: "https://vicariouscontent.com/webos",
  siteId: 6,
  trackerUrl: "https://analytics.vicariouscontent.com/matomo.php",
  srcUrl: "https://analytics.vicariouscontent.com/matomo.js",
  disabled: false,
  heartBeat: {
    active: true,
    seconds: 15,
  },
  linkTracking: true,
  configurations: {
    disableCookies: true,
    setSecureCookie: true,
    setRequestMethod: "POST",
  },
});

ReactDOM.render(
  <MatomoProvider value={instance}>
    <App />
  </MatomoProvider>,
  document.getElementById("root")
);
